import * as R from 'ramda';
import React, { useEffect, useState } from 'react';
// helpers/constants
import * as G from '../helpers';
// utilities
import { sendRequest } from '../utilities/http';
import endpointsMap from '../utilities/endpoints';
//////////////////////////////////////////////////

const useAsyncTelEvents = (telGuid) => {
  const [asyncEvents, setAsyncEvents] = useState(null);

  useEffect(() => {
    const getTelEventsRequest = async () => {
      const params = { telGuid };

      const res = await sendRequest('get', endpointsMap.telEventList, { params });

      const { data, status } = res;

      if (G.isResponseSuccess(status)) {
        setAsyncEvents(R.or(data, []));
      } else {
        G.handleFailResponseSimple(
          res,
          false,
          'withAsyncTelEvents -> getTelEventsRequest',
        );
      }
    };

    getTelEventsRequest();
  }, []);

  return asyncEvents;
};

export const withAsyncTelEvents = (Component) => (props) => {
  const { telGuid } = props;

  const asyncEvents = useAsyncTelEvents(telGuid);

  return <Component {...props} asyncEvents={asyncEvents} />;
};
